import React, { useEffect, Fragment } from 'react';
import { Form, Button, Row, Col, message } from 'antd';
import FormGroup from 'Molecules/FormGroup';
import { useForm } from 'react-hook-form';
import { useTranslate } from 'Translate';

const _ = require('lodash');

export default (props) => {
  const { data, editOutletReceipt, id, allowedEdit } = props;
  const { control, formState: { errors }, handleSubmit, setValue } = useForm();
  const i18n = useTranslate();
  const { t } = i18n;

  const formFields = [
    {
      type: 'input',
      name: 'qr_value',
      label: t("Outlet.qr_value"),
      req: false,
      placeholder: t("General.please_state"),
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      type: 'input',
      name: 'initial_running_no',
      label: t("Outlet.initial_running_no"),
      req: false,
      placeholder: t("General.please_state"),
      twocol: false,
      colWidth: '0 1 50%',
      reqmessage: t("General.required"),
      static: !allowedEdit,
      tips: t("Outlet.pls_enter_last_receipt_from_outlet"),
      wordCount: 6
    },
    {
      type: 'switch',
      name: 'receipt_hide_qr',
      label: 'Hide QR?',
      req: false,
      placeholder: t("General.please_select"),
      twocol: false,
      colWidth: '0 1 100%',
      reqmessage: t("General.required"),
      static: !allowedEdit
    },
    {
      name: 'receipt_footer_desc',
      label: t("Outlet.receipt_footer_desc"),
      req: false,
      placeholder: t("General.please_state"),
      type: 'textarea',
      twocol: false,
      colWidth: '0 1 100%',
      reqmessage: 'Receipt Footer Description Required',
      tips: t("Outlet.capped_at_48_char"),
      static: !allowedEdit
    },
  ];

  useEffect(() => {
    if (data && 'id' in data) {
      setValue('qr_value', data.qr_value);
      setValue('initial_running_no', data.initial_running_no);
      setValue('receipt_hide_qr', data.receipt_hide_qr === "1");
      setValue('receipt_footer_desc', data.receipt_footer_desc?.replace(/\|/g, "\n"));
    }
  }, [data]);

  const onFinish = async (val) => {
    props.setLoading(true);
    const payload = {
      ...val,
      receipt_hide_qr: val?.receipt_hide_qr ? "1" : "0",
      receipt_footer_desc: val?.receipt_footer_desc?.replace(/\n/g, "|"),
      id: id
    }

    await editOutletReceipt(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.receipt_edited"));
        // setTimeout(() => navigate("/outlets"), 500);
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message);
    })
  };

  return (
    <Form layout="vertical" onFinish={handleSubmit(onFinish)}>
      <Row gutter={[20, 30]}>
        {formFields.map((item, idx) => (
          <Fragment key={idx}>
            <FormGroup item={item} control={control} errors={errors} />
          </Fragment>
        ))}
        {
          allowedEdit &&
          <Col span={24} className='text-right'>
            <Button size="large" htmlType='submit' className='green-btn attendance-success'>{t("General.save")}</Button>
          </Col>
        }
      </Row>
    </Form>
  )
}